import languageBtn from './languageBtn'
import orderStatuses from './orderStatuses'
import common from './common'
import header from './header'
import callFeedback from './callFeedback'
import footerBtn from './footerBtn'
import mainPage from './mainPage'
import reschedule from './reschedule'
import signature from './signature'
import errorPage from './errorPage'
import access from './access'

export default {
  'language-btn': languageBtn,
  'order-status': orderStatuses, // 修正拼写错误：order-statuse -> order-status
  common,
  header,
  'call-feedback': callFeedback,
  'ready-for-delivery': '您的订单已安全存放在仓库，并将被送达 ',
  'footer-btn': footerBtn,
  'main-page': mainPage,
  reschedule,
  signature,
  'error-page': errorPage,
  access,
}
